import { MONTHS, MONTHS_FULL } from "../constants/form"

export const formatDate = date => {
  if (date === "Current") return "Current"
  const today = new Date()
  const sentDate = new Date(date)
  if (today.getTime() === sentDate.getTime()) {
    return "Today"
  } else {
    const day = sentDate.getDate()
    const month = sentDate.getMonth()
    const year = sentDate.getFullYear()
    return MONTHS[month] + " " + day + ", " + year
  }
}

export const formatTime = date => {
  const sentDate = new Date(date)
  const minutes = sentDate.getMinutes()
  let hours = sentDate.getHours()
  const prefix = hours >= 12 ? "PM" : "AM"
  hours = hours % 12
  const displayHours = hours ? hours : 12
  const displayMinutes = minutes < 10 ? "0" + minutes : minutes
  return displayHours + ":" + displayMinutes + " " + prefix
}

export const formatDateToBackend = date => {
  if (!date) return date
  const enteredDate = new Date(date)
  const year = enteredDate.getFullYear()
  const month = enteredDate.getMonth() + 1
  const day = enteredDate.getDate()
  return year + "-" + month + "-" + day
}

export const getCurrentAge = date => {
  const currentDate = new Date()
  const durationY = currentDate.getFullYear() - new Date(date).getFullYear()
  let durationM = currentDate.getMonth() - new Date(date).getMonth()

  if (durationM < 0) {
    durationM = 12 + durationM
  }
  return durationY + " years " + durationM + " months old"
}

export const getDateDifferenceInDays = expiry => {
  const today = new Date()
  const date = new Date(expiry)
  const diff = date - today
  return parseInt(diff / (24 * 3600 * 1000))
}

export const formatDateForCvExpiry = date => {
  const sentDate = new Date(date)
  const day = sentDate.getDate()
  const month = sentDate.getMonth()
  const year = sentDate.getFullYear()
  if (parseInt(day.toString().slice(-1)) === 1 && day !== 11) {
    return day + "st " + MONTHS_FULL[month] + ", " + year
  } else if (parseInt(day.toString().slice(-1)) === 2 && day !== 12) {
    return day + "nd " + MONTHS_FULL[month] + ", " + year
  } else if (parseInt(day.toString().slice(-1)) === 3 && day !== 13) {
    return day + "rd " + MONTHS_FULL[month] + ", " + year
  } else {
    return day + "th " + MONTHS_FULL[month] + ", " + year
  }
}
